import { fetchOrderReceiptPDFHTMLString } from "../HTTPRequests/OrderRequests";
import openErrorModal from "../Error/ErrorModal";
import Loader from "../DomUtilities/Loader";
import PrintHandler from "../DomUtilities/PrintHandler";

export default class OrderPrintHandler extends PrintHandler {
	orderId: string;
	htmlPDF: string;

	constructor(orderId: string, htmlPDF: string) {
		super(htmlPDF);
		this.orderId = orderId;

		this.init();
	}

	private init() {
		Loader.show();
		if (this.htmlPDF) {
			this.print(this.htmlPDF);
		} else {
			fetchOrderReceiptPDFHTMLString(this.orderId)
				.then((response: string) => {
					this.print(JSON.parse(response));
				}, () => { //backend error
					openErrorModal();
				}).catch(() => { //frontend error
					openErrorModal();
				}).finally(() => {
					Loader.hide();
				});
		}
	}
}
